import React from 'react';
import { Phone, Mail, MapPin, Instagram, ArrowUpRight, Globe } from 'lucide-react';
import { COMPANY } from '../data/site';
import { ContactForm } from './ContactForm';
import { WhatsAppLink, WhatsAppIcon } from './WhatsAppLink';

export const Contact = () => (
  <section id="contact" className="section-space contact-section" aria-labelledby="contact-heading" data-testid="contact-section">
    <div className="site-container contact-grid">
      <div className="contact-copy">
        <h2 className="section-kicker" id="contact-heading">VAMOS CONVERSAR</h2>
        <p className="section-title" data-testid="contact-title">Seu próximo projeto<br />começa aqui.</p>
        <p>Encontre a solução ideal para o seu espaço.<br />A FATT está pronta para ouvir você.</p>
        <a className="contact-phone" href={COMPANY.telephone} data-testid="contact-phone-link"><Phone size={24} />{COMPANY.phone}</a>
        <WhatsAppLink className="contact-whatsapp text-link" testId="contact-whatsapp"><WhatsAppIcon /> Prefere falar pelo WhatsApp? <ArrowUpRight size={17} /></WhatsAppLink>
        <div className="contact-details">
          <a href={`mailto:${COMPANY.email}`} data-testid="contact-email-link"><Mail size={19} /><span>{COMPANY.email}</span></a>
          <p data-testid="contact-address"><MapPin size={20} /><span>{COMPANY.address}<br />{COMPANY.city}</span></p>
          <a href={COMPANY.instagram} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram"><Instagram size={19} /><span>@fattelevadores</span><ArrowUpRight size={16} /></a>
          <a href={COMPANY.website} target="_blank" rel="noopener noreferrer" data-testid="contact-website"><Globe size={19} /><span>www.fattelevadores.com</span><ArrowUpRight size={16} /></a>
        </div>
      </div>
      <ContactForm />
    </div>
  </section>
);